<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="记录"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="showCheckbox"
      :show-query="showQuery"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange" size="mini">
            <el-option v-for="item in termList" :key="item.TermId" :value="item.TermId" :label="item.TermName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学生">
          <el-input size="mini" v-model="params.FullName" clearable placeholder="请填写学生姓名" />
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            size="mini"
            v-model="params.StartDate"
            placeholder="请选择日期"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            size="mini"
            v-model="params.EndDate"
            placeholder="请选择日期"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="FullName" label="姓名" />
        <el-table-column label="班级" min-width="100">
          <template slot-scope="{row}">
            <span>{{row.Grade + row.Class}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="AttendanceDate" label="日期" min-width="110">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.AttendanceDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="SectionName" label="节次" />
        <el-table-column prop="Remark" label="具体情况" min-width="140" />
        <el-table-column prop="HandleResult" label="处理结果" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" size="small" v-if="row.HandleResult==1">正常缺勤</el-tag>
            <el-tag type="danger" size="small" v-else-if="row.HandleResult==2">异常缺勤</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="HandleStatus" label="状态" width="90" align="center">
          <template slot-scope="{row}">
            <el-tag type="warning" size="small" v-if="row.HandleStatus==0">待处理</el-tag>
            <el-tag type="success" size="small" v-else-if="row.HandleStatus==1">已处理</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import termApi from "@/api/ed/term";
import exportDialog from "./exportDialog";

export default {
  mixins: [listMixin],
  components: { list,exportDialog },
  data() {
    return {
      api: require("@/api/st/attendance").default,
      params: {
        FullName: "",
        ClassTeacherId: null,
        StartDate: "",
        EndDate: "",
        TermId: null,
        Status: 0,
        IsLeave: false,
        IsMedical: false,
      },
      isMB: this.$store.state.isMB,
      termApi,
      termList: [],
    };
  },
  beforeMount() {
    let loginInfo = JSON.parse(localStorage.getItem("loginInfo"))
    this.params.ClassTeacherId = loginInfo.TeacherId
    this.params.TermId = loginInfo.TermId
    this.termApi.list().then(res => {
      this.termList = res.Data || []
      if(res.Data.length > 0) {
        if(!this.params.TermId) {
          this.params.TermId = res.Data[0].TermId
        }
        sessionStorage.setItem("termId",this.params.TermId)
        if(this.params.TermId < 0) {
          this.query({ TermId: res.Data[0].TermId })
        } 
      }
    })
  },
  methods: {
    onExport() {
      this.$refs.exportDialog.open().then((that) => {
        that.getData(this.params);
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    termChange(e) {
      sessionStorage.setItem("termId",e)
      let t = this.termList.find((x) => {
        if(e == x.TermId) {
          return x
        }
      })
      this.query({ TermId: e, FullName: this.params.FullName, ClassTeacherId: this.params.TeacherId, StartDate: this.params.StartDate, EndDate: this.params.EndDate })
    }
  },
};
</script>